var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_\\uAC1C\\uC778\\uD68C\\uC6D0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_61",
    "data-name": "\\uC0AC\\uAC01\\uD615 61",
    width: 50,
    height: 50,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_118",
    "data-name": "\\uADF8\\uB8F9 118",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_176",
    "data-name": "\\uD328\\uC2A4 176",
    d: "M42.967,46.554H7.033a.783.783,0,0,1-.783-.783c0-11.694.342-17.606,3.471-21.279,2.5-2.937,6.294-4.169,8.7-4.8-3.887-3.67-2.168-9.346-2.148-9.408.357-1.142,2.452-6.841,8.585-6.841a9.435,9.435,0,0,1,9,6.925c.754,3.893-.1,7.122-2.4,9.278,2.38.618,6.162,1.846,8.729,4.843,3.328,3.884,3.568,10.629,3.568,21.278a.784.784,0,0,1-.783.783M7.816,44.988H42.184c-.012-9.837-.291-16.092-3.191-19.477-2.621-3.06-6.842-4.087-8.871-4.58-.24-.058-.451-.11-.627-.156a.783.783,0,0,1-.217-1.42c3.478-2.189,3.574-5.927,3.042-8.678a7.774,7.774,0,0,0-7.464-5.665c-4.911,0-6.67,4.4-7.091,5.744-.018.058-1.75,5.77,2.827,8.647a.783.783,0,0,1-.221,1.421c-.172.044-.368.092-.586.144-2.05.5-6.317,1.54-8.873,4.539-2.726,3.2-3.081,8.7-3.1,19.481",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_177",
    "data-name": "\\uD328\\uC2A4 177",
    d: "M24.982,24.36a.779.779,0,0,1-.47-.157l-4.24-3.179a.783.783,0,1,1,.939-1.253L24.99,22.6l3.921-2.842a.783.783,0,0,1,.919,1.268l-4.389,3.18a.783.783,0,0,1-.459.149",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_178",
    "data-name": "\\uD328\\uC2A4 178",
    d: "M24.836,37.914h-.027a.782.782,0,0,1-.577-.283l-3.947-4.776a.788.788,0,0,1-.16-.672l2.253-9.919a.782.782,0,1,1,1.526.347l-2.167,9.543,3.138,3.8,3.49-3.7-2.3-9.628a.783.783,0,1,1,1.523-.363l2.4,10.038a.781.781,0,0,1-.191.719L25.4,37.668a.78.78,0,0,1-.568.246",
    fill: "#d8d8d8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon_개인회원.87fea59015199aad58c0fe6815308956.svg";
export { ForwardRef as ReactComponent };